export const VALIDATION_MESSAGES = {
  // Campos obrigatórios
  TITLE_REQUIRED: 'Por favor, preencha o campo "Título" antes de continuar.',
  SUMMARY_REQUIRED: 'Por favor, preencha o campo "Resumo" antes de continuar.',
  PROMPT_REQUIRED: 'Por favor, preencha o campo "Prompt" antes de continuar.',

  // Validações de palavras-chave (tags)
  INVALID_TAG: 'Não é permitido usar apenas underscores como palavra-chave.',
  INVALID_TAG_KEYWORD: 'Evite números puros, termos genéricos ou palavras muito curtas.',

  // Validações de categorias
  CATEGORIES_REQUIRED: 'Por favor, selecione pelo menos uma caracterização e finalidade.',
  FINALITY_REQUIRED: 'Por favor, selecione pelo menos uma finalidade.',

  // Termos e condições
  TERMS_REQUIRED: 'É necessário aceitar os termos de uso para continuar.',

  // Validações de conteúdo
  HTML_NOT_ALLOWED: 'O prompt não pode conter tags HTML. Por favor, remova as tags HTML do texto.',

  // Operações
  LOGIN_REQUIRED: 'Você precisa estar logado para realizar esta ação.',
  SELECT_RATING: 'Por favor, selecione uma nota antes de enviar a avaliação.',
} as const;

export const SUCCESS_MESSAGES = {
  AVATAR_UPDATED: 'Avatar atualizado com sucesso!',
  AVATAR_DELETED: 'Avatar deletado com sucesso!',
  AVATAR_UPLOADED: 'Avatar enviado com sucesso!',
  COPY_TEXT_SUCCESS: 'Texto copiado com sucesso!',
  PROMPT_SAVED: 'Prompt cadastrado com sucesso!',
  PROMPT_UPDATED: 'Prompt atualizado com sucesso!',
  PROMPT_DELETED: 'Prompt deletado com sucesso!',
  EVALUATION_SENT: 'Avaliação enviada com sucesso!',
  PROFILE_UPDATED: 'Perfil atualizado com sucesso!',
  COMMAND_COPIED: 'Comando copiado para a área de transferência!',
} as const;

export const ERROR_MESSAGES = {
  AVATAR_UPLOAD_FAILED: 'Falha ao enviar o avatar. Por favor, tente novamente.',
  AVATAR_DELETE_FAILED: 'Falha ao deletar o avatar. Por favor, tente novamente.',
  AVATAR_LOAD_FAILED: 'Falha ao carregar o avatar. Por favor, tente novamente.',
  AVATAR_CROP_FAILED: 'Falha ao recortar o avatar. Por favor, tente novamente.',
  COPY_COMMAND_FAILED: 'Não foi possível copiar o comando.',
  PROFILE_NO_CHANGES: 'Nenhuma alteração detectada no perfil.',
  GENERIC: 'Ocorreu um erro inesperado. Por favor, tente novamente.',
  NETWORK_ERROR: 'Não foi possível conectar ao servidor. Verifique sua conexão com a internet.',
  UNAUTHORIZED: 'Sua sessão expirou. Por favor, faça login novamente.',
  FORBIDDEN: 'Você não tem permissão para realizar esta ação.',
  NOT_FOUND: 'Recurso não encontrado.',
  SERVER_ERROR: 'Erro interno do servidor. Por favor, tente novamente mais tarde.',
  SAVE_FAILED: 'Não foi possível salvar o prompt. Por favor, tente novamente.',
  UPDATE_FAILED: 'Não foi possível atualizar o prompt. Por favor, tente novamente.',
  DELETE_FAILED: 'Não foi possível deletar o prompt. Por favor, tente novamente.',
  LOAD_FAILED: 'Não foi possível carregar os dados. Por favor, tente novamente.',
  SEARCH_FAILED: 'Não foi possível realizar a busca. Por favor, tente novamente.',
  EVALUATION_FAILED: 'Houve um erro ao enviar sua avaliação. Tente novamente.',
  COPY_FAILED: 'Não foi possível copiar o texto.',
  CATEGORIES_LOAD_FAILED: 'Não foi possível carregar as categorias. Por favor, tente novamente.',
} as const;

